import { Persona } from '@/types/persona';
import fetchWithAuth from './base';
import { ListResponse } from '@/types/common';

export const getPersonas = async ({
  clientId,
  startingAfter,
  endingBefore,
  limit,
  search,
}: {
  clientId: string;
  startingAfter?: string;
  endingBefore?: string;
  limit?: number;
  search?: string;
}): Promise<ListResponse<Persona>> => {
  const params = new URLSearchParams();
  if (startingAfter) {
    params.append('starting_after', startingAfter);
  }
  if (endingBefore) {
    params.append('ending_before', endingBefore);
  }
  if (limit) {
    params.append('limit', limit.toString());
  }
  if (search) {
    params.append('search', search);
  }

  const response = await fetchWithAuth(`/api/client/${clientId}/persona?${params.toString()}`, {
    method: 'GET',
  });
  return response.json();
};

export const getPersona = async (clientId: string, id: string): Promise<Persona> => {
  const response = await fetchWithAuth(`/api/client/${clientId}/persona/${id}`, {
    method: 'GET',
  });
  return response.json();
};

export const createPersona = async (clientId: string, data: Partial<Persona>) => {
  const response = await fetchWithAuth(`/api/client/${clientId}/persona`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  return response.json();
};

export const updatePersona = async (clientId: string, id: string, data: Partial<Persona>) => {
  const response = await fetchWithAuth(`/api/client/${clientId}/persona/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  return response.json();
};

export const deletePersona = async (clientId: string, id: string): Promise<void> => {
  await fetchWithAuth(`/api/client/${clientId}/persona/${id}`, {
    method: 'DELETE',
  });
};
